import React from 'react'
import { useHistory } from 'react-router-dom'
import expertService from 'services/experts'
import { useUsername } from 'context/username'
import { useLoading } from 'context/loading'
import killSession from 'utils/helpers/killSession'
import routesNames from 'routes/routesNames'
import { ExpertsAccountChangePassword as ExpertsAccountChangePasswordContainer } from 'containers'
import { getAuthToken } from 'utils/local-storage'
import { useFeedback } from 'context/feedback'

function AccountChangePassword() {
  const { state } = useUsername()
  const history = useHistory()
  const { dispatch: dispatchLoading } = useLoading()
  const { dispatch: dispatchFeedback } = useFeedback()

  function onExit() {
    killSession()

    history.push(routesNames.experts.login)
  }

  function onSubmit(values, setHasErrors) {
    const token = getAuthToken()
    const cleanValues = {
      new_password: values.new_password,
      old_password: values.old_password,
    }

    dispatchLoading({
      payload: true,
      type: 'set',
    })

    expertService.account
      .changePassword(cleanValues, token)
      .then((result) => {
        if (result.code === 200) {
          dispatchFeedback({
            payload: {
              message: 'Senha alterada com sucesso.',
              open: true,
              severity: 'success',
            },
            type: 'set',
          })
          dispatchLoading({
            payload: false,
            type: 'set',
          })

          history.push(routesNames.experts.account)
        }
      })
      .catch(() => {
        setHasErrors({
          message: 'Não foi possível alterar a senha.',
          show: true,
        })
        dispatchLoading({
          payload: false,
          type: 'set',
        })
      })
  }

  return (
    <ExpertsAccountChangePasswordContainer
      onExit={onExit}
      onSubmit={onSubmit}
      user={state.user}
    />
  )
}

export default AccountChangePassword
